<p-breadcrumb class="w-full mb-4 block" [model]="items">
    <ng-template pTemplate="item" let-item>
        <a [routerLink]="item.route" class="p-menuitem-link" [ngClass]="{'active-link': item.active}" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"> <span class="text-primary">{{ item.label }}</span></a>
    </ng-template>
</p-breadcrumb>